import { apiAxios } from "@helpers/lib/axios";
import { API_ENDPOINTS } from "@memorang/constants";
import type { BackendSessionResponse } from "@memorang/types/src/session/new-session";
import type {
	CreateSessionRequest,
	EndSessionRequest,
	EndSessionResponse,
	TrackAnswerEventRequest,
	TrackAnswerEventResponse,
	UserSessionsByType,
} from "./types";

export async function createSession(
	request: CreateSessionRequest,
): Promise<BackendSessionResponse> {
	const { data } = await apiAxios.post(API_ENDPOINTS.SESSIONS, request);

	return data.data;
}

export async function endSession(
	request: EndSessionRequest,
): Promise<EndSessionResponse> {
	const { data } = await apiAxios.post(
		API_ENDPOINTS.SESSION_END(request.sessionId),
	);

	return data.data;
}

export async function trackAnswerEvent(
	request: TrackAnswerEventRequest,
): Promise<TrackAnswerEventResponse> {
	const { data } = await apiAxios.post(API_ENDPOINTS.ANSWER_EVENTS, request);

	return data.data;
}

export const fetchSessionItems = async ({
	sessionId,
}: {
	sessionId: number;
}): Promise<BackendSessionResponse> => {
	const { data } = await apiAxios.get(API_ENDPOINTS.SESSION_ITEMS(sessionId));

	return data.data;
};

export const fetchUserSessions = async ({
	userId,
	collectionId,
	status,
}: {
	userId: number;
	collectionId?: number;
	status?: "ACTIVE" | "COMPLETE";
}): Promise<UserSessionsByType> => {
	const { data } = await apiAxios.get(API_ENDPOINTS.USER_SESSIONS(userId), {
		params: {
			...(collectionId ? { collectionId } : {}),
			...(status ? { status } : {}),
		},
	});

	// Defensive: the reconcile treats a successful empty result as "no session"
	// and clears the module, so never let an unexpected unwrapped shape read as
	// undefined and wipe every tracked session.
	return data.data ?? data;
};
